export function Pricing() {
  return `
    <section id="harga" class="section text-center">
      <div class="container">

        <h2 class="mb-3">Harga Layanan</h2>
        <p class="text-secondary mb-5">
          Pilih paket sesuai kebutuhan Anda
        </p>

        <div class="row g-4">

          ${PriceCard("Website Basic", "Mulai dari", "Rp 500K", [
            "Landing page sederhana",
            "Desain responsif",
            "1 halaman",
          ])}

          ${PriceCard(
            "Website Premium",
            "Mulai dari",
            "Rp 1.5JT",
            ["Multi halaman", "Custom desain", "Optimasi performa"],
            true,
          )}

          ${PriceCard("Undangan Digital", "Mulai dari", "Rp 100K", [
            "Undangan web / video",
            "Desain menarik",
            "Custom tema",
          ])}

        </div>

      </div>
    </section>

    ${OtherServices()}
  `;
}
function PriceCard(title, label, price, features, highlight = false) {
  const message = `Halo, saya tertarik dengan paket ${title} (${price}). Bisa minta detailnya?`;
  const encodedMessage = encodeURIComponent(message);
  const waLink = `https://wa.me/6283872687465?text=${encodedMessage}`;
  return `
    <div class="col-md-4">
      <div class="price-card p-4 h-100 ${highlight ? "highlight" : ""}">

        <h5>${title}</h5>
        <p class="text-secondary small">${label}</p>

        <h3 class="mb-3 text-danger">${price}</h3>

        <ul class="list-unstyled mb-4">
          ${features.map((f) => `<li class="mb-2">✔ ${f}</li>`).join("")}
        </ul>

        <a href="${waLink}" target="_blank" class="btn btn-danger w-100">
          Pilih Paket
        </a>

      </div>
    </div>
  `;
}
function OtherServices() {
  return `
    <section class="section text-center">
      <div class="container">

        <h4 class="mb-4">Layanan Lainnya</h4>

        <div class="row g-3">

          ${MiniPrice("Percetakan", "Mulai dari Rp 10K")}
          ${MiniPrice("Edit Foto Vektor", "Mulai dari Rp 25K")}
          ${MiniPrice("Instalasi CBT", "Mulai dari Rp 300K")}

        </div>

      </div>
    </section>
  `;
}

function MiniPrice(title, price) {
  return `
    <div class="col-md-4">
      <div class="mini-price p-3">
        <h6>${title}</h6>
        <p class="text-danger">${price}</p>
      </div>
    </div>
  `;
}
